// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 960 ? "codeSnippet" : chunkId) + "." + {"660":"e8f3f1400ac7117c7a09","720":"40c60019a79f48849329","960":"fd7de9d5b4c94cc3e2cf"}[chunkId] + ".js";
};